export default __webpack_public_path__ + "static/media/thumbnail-anymotion-mobile.5118100f.png";